var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3999 4.00002C1.3999 3.11637 2.11625 2.40002 2.9999 2.40002H20.9999C21.8814 2.40002 22.5999 3.11146 22.5999 3.99727V6.44995H23C23.3037 6.44995 23.55 6.69619 23.55 6.99995V8.99995C23.55 9.30371 23.3037 9.54995 23 9.54995H22.5999V18C22.5999 18.3314 22.3313 18.6 21.9999 18.6C21.6685 18.6 21.3999 18.3314 21.3999 18V5.59998H2.5999V20C2.5999 20.2209 2.77899 20.4 2.9999 20.4H20.5293C20.8607 20.4 21.1293 20.6687 21.1293 21C21.1293 21.3314 20.8607 21.6 20.5293 21.6H19.6001V23C19.6001 23.3313 19.3315 23.6 19.0001 23.6C18.6687 23.6 18.4001 23.3313 18.4001 23V21.6H5.6001V23C5.6001 23.3313 5.33147 23.6 5.0001 23.6C4.66873 23.6 4.4001 23.3313 4.4001 23V21.6H2.9999C2.11625 21.6 1.3999 20.8837 1.3999 20V4.00002ZM2.5999 4.39998H21.3999V3.99727C21.3999 3.77851 21.223 3.60002 20.9999 3.60002H2.9999C2.77899 3.60002 2.5999 3.77911 2.5999 4.00002V4.39998Z",
    fill: "#383634"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9999 8.40002C6.33127 8.40002 6.5999 8.66865 6.5999 9.00002V17C6.5999 17.3314 6.33127 17.6 5.9999 17.6C5.66853 17.6 5.3999 17.3314 5.3999 17V9.00002C5.3999 8.66865 5.66853 8.40002 5.9999 8.40002Z",
    fill: "#383634"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5999 9.00002C10.5999 8.66865 10.3313 8.40002 9.9999 8.40002C9.66853 8.40002 9.3999 8.66865 9.3999 9.00002V17C9.3999 17.3314 9.66853 17.6 9.9999 17.6C10.3313 17.6 10.5999 17.3314 10.5999 17V9.00002Z",
    fill: "#383634"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 8.40002C14.3313 8.40002 14.5999 8.66865 14.5999 9.00002V17C14.5999 17.3314 14.3313 17.6 13.9999 17.6C13.6685 17.6 13.3999 17.3314 13.3999 17V9.00002C13.3999 8.66865 13.6685 8.40002 13.9999 8.40002Z",
    fill: "#383634"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5999 9.00002C18.5999 8.66865 18.3313 8.40002 17.9999 8.40002C17.6685 8.40002 17.3999 8.66865 17.3999 9.00002V17C17.3999 17.3314 17.6685 17.6 17.9999 17.6C18.3313 17.6 18.5999 17.3314 18.5999 17V9.00002Z",
    fill: "#383634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatIcon);
export default __webpack_public_path__ + "static/media/heat_icon.39fab867f0e39b0328a78af11e9bd861.svg";
export { ForwardRef as ReactComponent };